import * as Fields from './fields';
import * as FormHelpers from './helpers';
import * as Steps from './steps';
import * as Widget from '../widgets/base';
import * as Attribution from '../driftrock_attribution';

function build_payload(config) {
  const field_inputs = Widget.get(config).querySelectorAll('.driftrock [data-form-field-value]');
  const fields =
    Object.fromEntries(
      [...field_inputs]
        .filter(field => field.dataset.visible != 'false')
        .map(field => {
          switch (field.dataset.formFieldType) {
            case "checkbox":
              return [field.dataset.formFieldName, field.checked.toString()]
              break;
            case "radiobuttons":
              const input = field.querySelector('input:checked')

              if (input) {
                return [field.dataset.formFieldName, input.value];
              } else {
                return [field.dataset.formFieldName, null];
              }

              break;
            default:
              return [field.name, field.value]
              break;
          }
        })
    );

  // we probably want to interpret "referer" as the page
  // the form is hosted on, but there might still value
  // in knowing the actual referer (let's keep this in mind)
  const referer = document.location.toString();
  const location_params = FormHelpers.locationParams(location.search)
  const first_touch = Attribution.get_first_touch();
  const ga_client_id = Attribution.calculate_ga_client_id(config);
  const hidden_fields = Driftrock.widget_settings.hidden_fields;
  var touch = {};

  if (first_touch) {
    touch = first_touch;
  } else {
    touch = {
      utm_campaign: location_params.utm_campaign,
      utm_content: location_params.utm_content,
      utm_medium: location_params.utm_medium,
      utm_source: location_params.utm_source,
      utm_term: location_params.utm_term || location_params.utm_keyword
    };
  }

  var payload = {
    event_name: 'Lead Submitted',
    event_type: 'lead',
    source_id: config.form.id,
    fields: { ...fields, ...hidden_fields },
    metadata: { ...touch }
  }

  if (ga_client_id) {
    payload.metadata.ga_client_id = ga_client_id;
  }

  if (referer) {
    payload.metadata.referer = referer;
  }

  return payload;
}

function send(payload, config) {
  return fetch(
    `${Driftrock.settings.base_url}/v2/widget_event`,
    {
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${Driftrock.settings.api_key}`,
        'Content-Type': 'application/json'
      },
      method: 'post',
      body: JSON.stringify(payload)
    }
  )
  .then(FormHelpers.handleApiError)
  .then(response => response.json())
}

export function send_event(config) {
  const payload = build_payload(config);

  return send(payload, config);
}
